<template>
  <div class="menu">
    <span class="button-menu-back sprite-return" @click="$emit('backMenu')"/>

    <button-menu
      :class="{disabled: !isImage, 'button-menu-selected': (showSlider && sliderType && sliderType.type === 'luminosity')}"
      ref="luminosity"
      :label="dictionnary ? dictionnary.adjustMenu.luminosite : ''"
      iconClass="sprite-luminosity"
      @click.native="openSlider('luminosity')"
    />
    <button-menu
      :class="{disabled: !isImage, 'button-menu-selected': (showSlider && sliderType && sliderType.type === 'contrast')}"
      ref="contrast"
      :label="dictionnary ? dictionnary.adjustMenu.contraste : ''"
      iconClass="sprite-contrast"
      @click.native="openSlider('contrast')"
    />
    <button-menu
      :class="{disabled: !isImage,'button-menu-selected': (showSlider && sliderType && sliderType.type === 'saturate')}"
      ref="saturate"
      :label="dictionnary ? dictionnary.adjustMenu.saturation : ''"
      iconClass="sprite-saturate"
      @click.native="openSlider('saturate')"
    />
    <button-menu
      :class="{disabled: !isImage,'button-menu-selected': (showSlider && sliderType && sliderType.type === 'blur')}"
      ref="blur"
      :label="dictionnary ? dictionnary.adjustMenu.flou :''"
      iconClass="sprite-blur"
      @click.native="openSlider('blur')"
    />
    <button-menu
      ref="opacity"
      :class="{'button-menu-selected': (showSlider && sliderType && sliderType.type === 'opacity')}"
      :label="dictionnary ? dictionnary.adjustMenu.opacite : ''"
      iconClass="sprite-opacity"
      @click.native="openSlider('opacity')"
    />
    <span class="separator"/>
    <button-menu
      :label="dictionnary ? dictionnary.adjustMenu.rotation :''"
      iconClass="sprite-rotate"
      @click.native="onRotate"
    />
    <button-menu
      :label="dictionnary ? dictionnary.adjustMenu.hauteur : ''"
      iconClass="sprite-full-height"
      @click.native="onFullSize('height')"
    />
    <button-menu
      :label="dictionnary ? dictionnary.adjustMenu.largeur : ''"
      iconClass="sprite-full-width"
      @click.native="onFullSize('width')"
    />
    <transition name="fade">
      <slider
        ref="slider"
        :config="sliderType"
        v-if="showSlider"
        @close="showSlider=false"
        @input="updateSliderValue"
        @change="onChange"
      />
    </transition>
  </div>
</template>
<script>
const LUMINOSITY_INDEX = 1
const CONTRAST_INDEX = 2
const SATURATE_INDEX = 3
const BLUR_INDEX = 5

import ButtonMenu from '@/components/buttons/ButtonMenu'
import Slider from '@/components/slider/Slider'
import menu from './menu-default'
import { mapGetters } from 'vuex'
import { fabric } from 'fabric'
import { defined } from 'junctions-fp'

export default {
  name: 'AjustementsMenu',
  mixins: [menu],
  components: {
    ButtonMenu,
    Slider
  },
  beforeCreate() {},
  created() {},

  beforeMount() {},
  mounted() {},
  beforeUpdate() {},
  updated() {},
  beforeDestroy() {},
  destroyed() {},
  data() {
    return {
      dictionnary: null,
      showSlider: false,
      sliderType: null,
      oldOpacity: 1,
      currentFilter: null
    }
  },
  props: {},
  computed: {
    ...mapGetters(['getLanguages'])
  },
  methods: {
    onFullSize(direction) {
      this.templateModified()
      this.editor.fullSize(direction)
    },
    onRotate() {
      this.templateModified()
      this.editor.rotate()
    },
    hideSlider(event) {
      if (
        this.$refs.slider &&
        !this.$refs.slider.$el.contains(event.target) &&
        !this.$refs.luminosity.$el.contains(event.target) &&
        !this.$refs.contrast.$el.contains(event.target) &&
        !this.$refs.saturate.$el.contains(event.target) &&
        !this.$refs.blur.$el.contains(event.target) &&
        !this.$refs.opacity.$el.contains(event.target)
      ) {
        this.showSlider = false
        window.removeEventListener('click', this.hideSlider)
      }
    },
    openSlider(type) {
      switch (type) {
        case 'luminosity':
          this.sliderType = {
            icon: 'sprite-small-luminosity',
            label: this.dictionnary.adjustMenu.luminosite,
            min: -100,
            max: 100,
            type,
            value: this.getCurrentFilterValue(type)
          }
          break
        case 'contrast':
          this.sliderType = {
            icon: 'sprite-small-contrast',
            label: this.dictionnary.adjustMenu.contraste,
            min: -100,
            max: 100,
            type,
            value: this.getCurrentFilterValue(type)
          }
          break
        case 'saturate':
          this.sliderType = {
            icon: 'sprite-small-saturate',
            label: this.dictionnary.adjustMenu.saturation,
            min: -100,
            max: 100,
            type,
            value: this.getCurrentFilterValue(type)
          }
          break
        case 'blur':
          this.sliderType = {
            icon: 'sprite-small-blur',
            label: this.dictionnary.adjustMenu.flou,
            min: 0,
            max: 100,
            type,
            value: this.getCurrentFilterValue(type)
          }
          break
        case 'opacity':
          this.sliderType = {
            icon: 'sprite-small-opacity',
            label: this.dictionnary.adjustMenu.opacite,
            min: 0,
            max: 100,
            type,
            value: this.getCurrentFilterValue(type)
          }
          break
      }
      if (this.showSlider === false) {
        this.showSlider = true
        window.addEventListener('click', this.hideSlider)
      }
    },

    getCurrentFilterValue(type) {
      const current = this.editor.getCurrentSelectedObject()
      if (current && current.type === 'image' && type !== 'opacity') {
        switch (type) {
          case 'luminosity':
            return current.filters[LUMINOSITY_INDEX] ? current.filters[LUMINOSITY_INDEX].brightness * 100 : 0
          case 'contrast':
            return current.filters[CONTRAST_INDEX] ? current.filters[CONTRAST_INDEX].contrast * 100 : 0
            break
          case 'saturate':
            return current.filters[SATURATE_INDEX] ? current.filters[SATURATE_INDEX].saturation * 100 : 0
            break
          case 'blur':
            return current.filters[BLUR_INDEX] ? current.filters[BLUR_INDEX].blur * 100 : 0
            break
        }
      }
      if (type === 'opacity') {
        return this.editor.getOpacity() ? this.editor.getOpacity() * 100 : 100
      }
      return 0
    },

    changeOpacity(value) {
      this.editor.setOpacity(value / 100)
    },

    onChange(value) {
      const v = value.value / 100
      if (value.type === 'opacity') {
        this.editor.saveOpacity(v, this.oldOpacity)
        this.oldOpacity = v
        this.templateModified()
      } else {
        this.editor.addFilter(this.currentFilter.f, this.currentFilter.i, true)
      }
    },
    updateSliderValue(data) {
      if (data.type === 'opacity') {
        this.changeOpacity(data.value)
        return
      }
      switch (data.type) {
        case 'luminosity':
          this.currentFilter = { f: new fabric.Image.filters.Brightness({ brightness: data.value / 100 }), i: LUMINOSITY_INDEX }
          break
        case 'contrast':
          this.currentFilter = { f: new fabric.Image.filters.Contrast({ contrast: data.value / 100 }), i: CONTRAST_INDEX }
          break
        case 'saturate':
          this.currentFilter = { f: new fabric.Image.filters.Saturation({ saturation: data.value / 100 }), i: SATURATE_INDEX }
          break
        case 'blur':
          this.currentFilter = { f: new fabric.Image.filters.Blur({ blur: data.value / 100 }), i: BLUR_INDEX }
          break
      }

      this.editor.addFilter(this.currentFilter.f, this.currentFilter.i)
    }
  },
  watch: {}
}
</script>



// WEBPACK FOOTER //
// src/components/menu/AjustementsMenu.vue